import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import CustomReviewsCarousel from '../CustomReviewsCarousel'
import OfficialTrustpilotReviewsHolder from '../OfficialTrustpilotReviewsHolder'
import { getCustomReviewsForRoute } from '../customTrustpilotReviews'

const Reviews = ({ reviewRouteKey }) => {
  const { t } = useTranslation('Home')
  const router = useRouter()
  const customReviews = getCustomReviewsForRoute(
    reviewRouteKey || router.asPath,
    router.query
  )

  return (
    <section className='bg-[#F7F7F7] py-32 md:py-50 xl:py-96'>
      <div className='container mx-auto'>
        <div className='text-center mb-24 md:mb-40 px-16'>
          <h2 className='text-[28px] font-semibold leading-[36px] text-black md:text-[32px] md:leading-[40px]'>
            {'Dicono '}
            <span className='font-bold text-green'>
              {t('di noi')}
            </span>
          </h2>
        </div>

        {customReviews ? (
          <CustomReviewsCarousel reviews={customReviews} />
        ) : (
          <OfficialTrustpilotReviewsHolder />
        )}
      </div>
    </section>
  )
}

export default Reviews
